module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/inMkSP/tc-custom/9783987441141.jpg?1704395571405",
      "alt": "This image is the cover for the book Ruth, Classics To Go"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Ruth, Classics To Go\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Elizabeth Gaskell tells the story of a fallen woman in the Victorian period in her novel Ruth. When Ruth Hilton's parents die, her guardian helps her to secure the position of an apprentice at a seamstress' shop. Sixteen year old Ruth is befriended by Mr. Bellingham who convinces her that he is in love with her.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Elizabeth Cleghorn Gaskell\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Elizabeth Cleghorn Gaskell (née Stevenson; 29 September 1810 – 12 November 1865), often referred to as Mrs Gaskell, was an English novelist, biographer and short story writer. Her novels offer a detailed portrait of the lives of many strata of Victorian society, including the very poor. Her work is of interest to social historians as well as readers of literature. Her first novel, Mary Barton, was published in 1848. Gaskell's The Life of Charlotte Brontë, published in 1857, was the first biography of Charlotte Brontë. In this biography, she wrote only of the moral, sophisticated things in Brontë's life; the rest she left out, deciding that certain, more salacious aspects were better kept hidden. Among Gaskell's best known novels are Cranford (1851–53), North and South (1854–55), and Wives and Daughters (1865), each having been adapted for television by the BBC.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    OTB ebook\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0